import {useRefetchOnAliveUpdate} from './use-refetch-on-alive-update'
import {useLabelsQuery} from '../components/overview/data/route-queries'
import type {AliveChannels} from '../page-data/payloads/header'

export function useLabelsLiveUpdates(aliveChannels: AliveChannels): void {
  const {refetch} = useLabelsQuery()
  useRefetchOnAliveUpdate(aliveChannels.pullRequest, refetch, {labels_updated: true})
}
